import React, { useContext } from "react";

// AssetDownloadContext
import AssetDownloadContext from "core/AssetDownload/Context";
import { purchaseTypeKeys } from "photos/PhotoDetail/assetDownloadConfig";

// styles
import { ReadyForDownloadStyled } from "./styles";

const ReadyForDownload = () => {
    const {
        state: { isReadyForDownload, purchaseType }
    } = useContext(AssetDownloadContext);

    if (!isReadyForDownload) {
        return null;
    }

    const message =
        purchaseType?.key === purchaseTypeKeys.creativePro
            ? "Thanks, Pro! Ready for download"
            : "Ready for download";

    return <ReadyForDownloadStyled>{message}</ReadyForDownloadStyled>;
};

export default ReadyForDownload;
